'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useRegisterLimitations } from '@/modules/register/hooks/useRegisterLimitations';
import { removeUtmQueries } from '@/utils/queryString';

export const useGetLoginLink = () => {
  const { loginLink } = useRegisterLimitations();

  const pathname = usePathname();
  const searchParams = useSearchParams();

  const fullPath = searchParams?.toString()
    ? `${pathname}?${searchParams.toString()}`
    : pathname;

  const sanitizedPath: string = removeUtmQueries(fullPath);

  return {
    loginLink: `${loginLink}?backUrl=${encodeURIComponent(sanitizedPath)}`,
  };
};
